<script lang="ts">
    import { Col } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import { chart } from "svelte-apexcharts";
    import { UserActivations } from "../../../Data/Chart/Dashboard/Default/Chart";
    import {YearlyUser, Useractivations } from "../../../utils/Constant/Constant";
</script>

<Col xl="12" class="box-col-6 des-xl-50">
    <Card cardBodyprops="p-0">
        <div class="header-top d-sm-flex align-items-center" slot="customheader" >
        <h5>{Useractivations}</h5>
        <div class="center-content">
            <p>{YearlyUser} 24.65k</p>
        </div>
        </div>
        <div slot="contentbody" class="p-0">
            <div id="user-activation-dash-2">
                <div use:chart={UserActivations} />
            </div>
        </div>
    </Card>
</Col>